import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';

import { Document } from '../_models/document';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StringMap } from '@angular/compiler/src/compiler_facade_interface';
import { AppConfig } from 'src/assets/config/config/app-config';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class MigrationService {
  apiUrl: StringMap;
  allVFolders = [];
  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
    this.apiUrl = this.config.getConfig('apiUrl');
  }

  deleteDocument(req: any): Observable<any>{
    return this.http
      .post<any>(this.apiUrl + `/documents/capture/remove`, req)

      .pipe();

  }

  assignTeam(req: any): Observable<any>{
    return this.http
      .post<any>(this.apiUrl + `/fileInbox/team/assign`, req)

      .pipe();

  }

  getReport(): Observable<any>{
    return this.http
      .get<any>(this.apiUrl + `/documents/capture/report/get`)

      .pipe();

  }

  getTeamReport(): Observable<any>{
    return this.http
      .get<any>(this.apiUrl + `/documents/capture/report/team/get`)

      .pipe();

  }


  deleteFolder(req: any): Observable<any>{
    return this.http
      .post<any>(this.apiUrl + `/fileInbox/virtual-folder/remove`, req)

      .pipe();

  }

  deleteTeam(req: any): Observable<any>{
    return this.http
      .post<any>(this.apiUrl + `/fileInbox/team/remove`, req)

      .pipe();

  }

  createTeam(req: any): Observable<any>{
    return this.http
      .post<any>(this.apiUrl + `/fileInbox/team/create`, req)

      .pipe();

  }

  updateTeam(req: any): Observable<any>{
    return this.http
      .put<any>(this.apiUrl + `/fileInbox/team/update`, req)

      .pipe();

  }

  updateDuplicate(req: any): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + `/documents/capture/duplicate/update`, req)

      .pipe();
  }

  removeDuplicate(req: any): Observable<any> {
    return this.http
      .post<any>(this.apiUrl + `/documents/capture/remove`, req)

      .pipe();
  }

  getTeamsAll(): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/fileInbox/team/all`)
      .pipe();
  }

  getTeamsTree(): Observable<any> {
    return this.http
      .get<any>(this.apiUrl + `/fileInbox/team/tree`)
      .pipe();
  }

  getTeam(teamId, type, folderId, offset): Observable<any> {
    if (type === "folder") {
      return this.http.get<any>(this.apiUrl + `/fileInbox/team/` + teamId+`?folderId=`+folderId+`&type=`+type+`&offset=`+offset+`&limit=200`)
        .pipe(
        );
    }else {
      return this.http.get<any>(this.apiUrl + `/fileInbox/team/` + teamId+`?type=`+type+`&offset=`+offset+`&limit=200`)
        .pipe(
        );
    }
    
  }

  async getFlattenedTeamTree() {
    this.allVFolders = [];
    let teams = await this.http.get<any[]>(this.apiUrl + `/fileInbox/team/tree`).toPromise()
    this.flattenVirtualTeam(teams);
    return  this.allVFolders
}

  private flattenVirtualTeam(teams) {
    for (let i = 0; i < teams.length; i++) {
        let tempFolder = teams[i];
        if (tempFolder['sub_folders']) {
            this.flattenVirtualTeam(tempFolder['sub_folders'])

            if (!this.allVFolders.some(el => el.id === tempFolder['id'])) {
                this.allVFolders.push(tempFolder);
            }
        } else {
            if (!this.allVFolders.some(el => el.id === tempFolder['id'])) {
                this.allVFolders.push(tempFolder)
            }
        }
    }
}


}
